<template>
  <div v-if="!isNull" class="flex items-center justify-between px-3 py-3 my-2 rounded shadow">
    <a @click="onView" :class="isDisableClick ? 'disable-click' : ''">
      <template v-if="object.name">{{ object.name }}</template>
      <template v-else>{{ $t('product.document_index', { index: indexNumber }) }}</template>
      <template v-if="isShowDateEdit">
        <div class="note" v-if="object.updatedBy">{{ $t('product.last_updated_by') }} {{ object.updatedByText }}</div>
        <div class="note" v-if="object.updatedAt">{{ $t('product.last_updated_at') }} {{ object.updatedAtText }}</div>
      </template>
    </a>
    <div>
      <v-btn color="warning" class="ml-2" small elevation="0" @click="onUpdated" v-if="isUpdate"
        :disabled="isDisabled">{{ $t('action_type.edit') }}</v-btn>
      <v-btn color="error" class="ml-2" small elevation="0" @click="onRemove" :disabled="isDisabled">{{ $t('action_type.delete') }}</v-btn>
    </div>
  </div>
  <div v-else class="flex items-center justify-between px-3 py-3 my-2 rounded shadow text-gray-400">{{ $t('product.no_list_of_document') }}
  </div>
</template>
<script>
export default {
  props: {
    object: Object,
    indexNumber: String,
    isNull: Boolean,
    isUpdate: {
      type: Boolean,
      default: true
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isDisableClick: {
      type: Boolean,
      default: false
    },
    isShowDateEdit: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onView() {
      this.$emit("onView");
    },
    onUpdated() {
      this.$emit("onUpdated");
    },
    onRemove() {
      this.$emit("onRemove");
    }
  }
};
</script>
<style scoped lang="scss">
.disable-click {
  pointer-events: none;
  color: #b0b0b0;
}

.note {
  color: gray;
  font-size: 12px;
}
</style>